export default __webpack_public_path__ + "media/images/appel-d1032917a36f9efeb7fbfd0f125a4706.png";